module.exports = __webpack_public_path__ + "static/img/23.566f234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/23.jpg
// module id = MfcT
// module chunks = 0